import FileDrop from "./components/FileDrop/FileDrop";
const App = () => {
  return (  
      <FileDrop />
  );
};
export default App;